import * as actionTypes from './settingsActionTypes';

const initialState = {
    appsettings: null,
}

export default function settings(state = initialState, action) {
    switch (action.type) {
        case (actionTypes.APPSETTINGS):
            if (state.appsettings !== action.appsettings) {
                return Object.assign({}, state, { appsettings: action.appsettings });
            }
            return state;        
        default:
            return state;
    }
}